// GET_CURRENCY
export const GET_QUOTE_LIST = "GET_QUOTE_LIST";
export const GET_QUOTE_LIST_FAIL = "GET_QUOTE_LIST_FAIL";
export const GET_QUOTE_LIST_SUCCESS = "GET_QUOTE_LIST_SUCCESS";

export const CREATE_TRANSACTION = "CREATE_TRANSACTION";
export const CREATE_TRANSACTION_FAIL = "CREATE_TRANSACTION_FAIL";
export const CREATE_TRANSACTION_SUCCESS = "CREATE_TRANSACTION_SUCCESS";

